import React, { useState } from 'react';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest';
import { getMbmOptions } from '../helpers';
import RunsList from './RunsList';
import FileBrowser from './FileBrowser';
import { Row, Text, Masthead, MastheadMenuButton, MastheadTitle, SideMenu, SideMenuLink } from '@amzn/meridian';

const mbmOptions = getMbmOptions(arbManifest);

const App = () => {
    const [selectedRunId, setSelectedRunId] = useState<string | null>(null);
    const [sideMenuOpen, setSideMenuOpen] = useState(false);

    const handleMenuClick = () => {
        setSideMenuOpen(!sideMenuOpen);
    };

    const handleRunSelect = (runId: string) => {
        setSelectedRunId(runId);
        setSideMenuOpen(true);
    };

    const handleBackToRuns = () => {
        setSelectedRunId(null);
    };

    return (
        <MbmProvider {...mbmOptions}>
            <Masthead>
                <MastheadMenuButton onClick={handleMenuClick} />
                <MastheadTitle>
                    <Row alignmentVertical="center">
                        <Text type="b500">Flume Viewer</Text>
                    </Row>
                </MastheadTitle>
            </Masthead>
            <div style={{ display: 'flex', height: 'calc(100vh - 56px)' }}>
                {selectedRunId && (
                    <FileBrowser 
                        runId={selectedRunId} 
                        onBack={handleBackToRuns}
                        sidebarOpen={sideMenuOpen}
                    />
                )}
                {!selectedRunId && (
                    <>
                        <SideMenu open={sideMenuOpen} width={280}>
                            <SideMenuLink selected={true}>
                                Simulation Runs
                            </SideMenuLink>
                        </SideMenu>
                        <div style={{ flex: 1, padding: '20px', overflow: 'auto' }}>
                            <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                                <RunsList onSelectRun={handleRunSelect} />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </MbmProvider>
    );
};

export default App;
